import { render } from "./viewpurchaseinvoice.vue?vue&type=template&id=4bf1f360&scoped=true"
import script from "./viewpurchaseinvoice.vue?vue&type=script&lang=js"
export * from "./viewpurchaseinvoice.vue?vue&type=script&lang=js"

import "./viewpurchaseinvoice.vue?vue&type=style&index=0&id=4bf1f360&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf1f360"]])

export default __exports__